import api from "../services/api";

let cache = null;
let inflight = null;

export const fetchQueuesCached = async ({ force = false } = {}) => {
  if (!force && cache) {
    return cache;
  }

  if (!force && inflight) {
    return inflight;
  }

  inflight = api
    .get("/queue")
    .then(({ data }) => {
      cache = Array.isArray(data) ? data : [];
      return cache;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
};

export const clearQueuesCache = () => {
  cache = null;
  inflight = null;
};
